import VueI18n from 'vue-i18n';
import Vue from 'vue';
import getTranslations from '@/commons/translation';
import {bg, cs, de, en, es, fr, it, pl, ru, sk} from 'vuejs-datepicker/dist/locale';

const storeOptions = JSON.parse(process.env.VUE_APP_STORE_OPTIONS);

Vue.use(VueI18n);

export const i18n = new VueI18n({
    // eslint-disable-next-line no-underscore-dangle
    locale: storeOptions.locale || window.__INITIAL_STATE__.settings.locale,
    formatFallbackMessages: true,
    messages: getTranslations(),
});

export const datepickerLocales: any = {
    it,
    en,
    ru,
    pl,
    de,
    fr,
    es,
    cs,
    bg,
    sk,
};
